import { useState } from "react"
import { MessageCirclePlus, Users, UserPlus } from "lucide-react"
import { RibbonBackground } from "./presenceBgAnimation"
import { useTranslation } from "@/clientWeb/i18n/LanguageContext"
import { ShareDialog } from "@/clientWeb/components/ui/ShareDialog"

interface EmptyStateProps {
  onNewChat?: () => void
  onNewGroup?: () => void
}

export function EmptyState({ onNewChat, onNewGroup }: EmptyStateProps) {
  const t = useTranslation()
  const [showInvite, setShowInvite] = useState(false)

  return (
    <>
    <RibbonBackground>
    <div className="flex flex-col items-center justify-center h-full text-center px-12">
      {/* Illustration */}
      <div className="w-40 h-40 flex items-center justify-center mb-2">
        {/* <MessageCirclePlus className="w-20 h-20 text-primary/20" strokeWidth={1} /> */}
        <img src="/images/welcomepresence.svg" alt=""/>
      </div>

      <h3 className="text-lg font-semibold text-foreground mb-2">
        {t("presence.startConversation")}
      </h3>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mb-8">
        {t("presence.selectConversation")}
      </p>

      {/* Action buttons */}
      <div className="flex items-center gap-3">
        <button
          onClick={onNewChat}
          className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          <MessageCirclePlus className="w-4 h-4" />
          {t("presence.newChat")}
        </button>
        <button
          onClick={onNewGroup}
          className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-primary text-primary text-sm font-medium hover:bg-primary/5 transition-colors"
        >
          <Users className="w-4 h-4" />
          {t("presence.newGroup")}
        </button>
        <button
          onClick={() => setShowInvite(true)}
          className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-border text-muted-foreground text-sm font-medium hover:bg-muted/50 hover:text-foreground transition-colors"
        >
          <UserPlus className="w-4 h-4" />
          {t("presence.invite")}
        </button>
      </div>
    </div>
    </RibbonBackground>

    <ShareDialog
      isOpen={showInvite}
      onClose={() => setShowInvite(false)}
      url="https://inmeet.app/invite"
      title={t("presence.invitePeople")}
    />
    </>
  )
}
